export default __webpack_public_path__ + "static/media/ivan_avatar.19f663df.jpg";